type Result = {
	locations: Array<
		Readonly<{
			location: string;
			slug: string;
		}>
	>;
};

export const useMostVisitedLocationSection = (): Result => {
	const states = [
		{ location: 'Seattle', slug: 'seattle--wa--us' },
		{ location: 'Los Angeles', slug: 'losangeles--ca--us' },
		{ location: 'Salt Lake City', slug: 'saltlakecity--ut--us' },
		{ location: 'Chicago', slug: 'chicago--il--us' },
		{ location: 'New York', slug: 'newyork--ny--us' },
		{ location: 'San Diego', slug: 'sandiego--ca--us' },
		{ location: 'Bakersfield', slug: 'bakersfield--ca--us' },
		{ location: 'Houston', slug: 'houston--tx--us' },
		{ location: 'Spokane', slug: 'spokane--wa--us' },
		{ location: 'Dallas', slug: 'dallas--tx--us' },
		{ location: 'Olympia', slug: 'olympia--wa--us' },
		{ location: 'Bradenton', slug: 'bradenton--fl--us' },
		{ location: 'Atlanta', slug: 'atlanta--ga--us' },
		{ location: 'Miami', slug: 'miami--fl--us' },
		{ location: 'Phoenix', slug: 'phoenix--az--us' },
		{ location: 'San Jose', slug: 'sanjose--ca--us' },
		{ location: 'Charlotte', slug: 'charlotte--nc--us' },
		{ location: 'Las Vegas', slug: 'lasvegas--nv--us' },
		{ location: 'Sacramento', slug: 'sacramento--ca--us' },
		{ location: 'Denver', slug: 'denver--co--us' },
	];

	return {
		locations: states,
	};
};
